<template>
    <div class="qiancai">
        <div class="first">
            <div class="content">
                <div class="text">
                    <p>
                        <span>千采</span><span>报价小程序</span>
                    </p>
                    <p>
                        千采报价小程序搭建同业间交流的桥梁，营造金融同业信息共享生态圈，改善目前金融同业间信息不对称的现状，为业界提供更能解决同业痛点的沟通和管理工具。
                    </p>
                </div>
                <img src="../assets/qiancai-back-code.png"
     srcset="../assets/qiancai-back-code@2x.png 2x,
             ../assets/qiancai-back-code@3x.png 3x" class="imgOne">

                <img src="../assets/qiancai-back-phone.png"
     srcset="../assets/qiancai-back-phone@2x.png 2x,
             ../assets/qiancai-back-phone@3x.png 3x" class="imgTwo">
            </div>
        </div>
        <div class="second">
            <p>报价行情展示更符合机构投资者需求，</p>
            <p>支持保存个性化筛选方案。</p>
            <img src="../assets/qiancai-back-people.png"
     srcset="../assets/qiancai-back-people@2x.png 2x,
             ../assets/qiancai-back-people@3x.png 3x">
        </div>
    </div>
</template>
<script>
export default {
    name: 'Qiancai'
}
</script>

<style lang="scss">
.qiancai{
    min-width: 1000px;
    .first{
        min-height: 490px;
        margin-bottom: 177px;
        background: url("../assets/qiancai-back-first.jpg") no-repeat center/cover;
        @media only screen and (min--moz-device-pixel-ratio: 2),

        only screen and (-o-min-device-pixel-ratio: 2/1),

        only screen and (-webkit-min-device-pixel-ratio: 2),

        only screen and (min-device-pixel-ratio: 2){
            background: url("../assets/qiancai-back-first@2x.jpg") no-repeat center/cover;
        }
        @media only screen and (min--moz-device-pixel-ratio: 3),

        only screen and (-o-min-device-pixel-ratio: 3/1),

        only screen and (-webkit-min-device-pixel-ratio: 3),

        only screen and (min-device-pixel-ratio: 3){
            background: url("../assets/qiancai-back-first@3x.jpg") no-repeat center/cover;
        }
        .content{
            width: 1000px;
            margin: 0 auto;
            color: #fff;
            padding:1px;
            position: relative;
            .text{
                width: 413px;
                margin-top: 147px;
                margin-left: 85px;
                p:nth-child(1){
                    font-size: 40px;
                    font-weight: bold;
                    line-height: 1.5;
                    margin-bottom: 22px;
                    span:nth-child(1){
                        color:#fcc617
                    }
                }
                p:nth-child(2){
                    width: 368px;
                    font-size: 14px;
                    line-height: 1.86;
                }
            }
            img{
                position: absolute;
            }
            img.imgOne{
                right: 260px;
                top: 286px;
                z-index: 1;
            }
            img.imgTwo{
                right: 50px;
                top: 75px;
            }
        }
    }
    .second{
        height: 495px;
        text-align: center;
        p{
            font-size: 30px;
            font-weight: bold;
            line-height: 1.33;
            text-align: center;
            color: #000;
        }
        img{
            margin-top: 80px;
        }
    }

}
</style>